import { FormItem, NumberInput } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import { INumberWidget } from './INumberWidget';

export const NumberWidgetConfigSchema: yup.ObjectSchema<INumberWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Number).required(),
    decimalSize: yup
      .number()
      .min(0)
      .notRequired()
      .nullable()
      .label('Numero massimo cifre decimali'),
  });

export interface INumberWidgetConfigComponentProps
  extends IWidgetComponentProps<INumberWidget> {}

export function NumberWidgetConfigComponent(
  props: INumberWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <FormItem name="decimalSize" label="Numero massimo cifre decimali">
        <NumberInput name="decimalSize" allowClear min={0} />
      </FormItem>
    </>
  );
}
